import React, {Component} from 'react';
import {
    Dimensions,
    StyleSheet,
    Image,
    ScrollView,
    TouchableOpacity,
    View, Share, Platform, Alert, Linking, KeyboardAvoidingView, ImageBackground
} from 'react-native';
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import {moderateScale} from "../../../../tools/Scaling";

import {connect} from "react-redux";
import HMListItem from "../../../../customviews/HMListItem";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import i18n from "../../../../I18n/i18n";
import PathFile from "../../../../assets/PathFile";

import {typeExport} from "../../../../redux/store/type";
import HMIcon from "../../../../customviews/HMIcon";

import {exitApp, onShare} from "../../../../tools/Tools1";


const window = Dimensions.get('window');


class ProfileSatiaScreen extends Component {
    state = {
        showDialogCompetitions: false
    }

    constructor() {
        super();
    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };

    hideMenu = () => {
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    /*   async remove() {
           store.dispatch(serviceActionSetToken(null))
           try {
               //await AsyncStorage.removeItem(IDCITY);
               await AsyncStorage.removeItem(TOKEN);
           } catch (error) {
               alert(i18n.t('constant.retry'))
           }
       }*/


    onShare() {
        let data = this.props.DataSplashSatiaScreen.results.info;
        Share.share(
            {
                message: Platform.OS === "ios" ? data.description + "\n" + data.ios.link : data.description + "\n" + data.android.link,
                url: Platform.OS === "ios" ? data.ios.link : data.android.link,
            }
        ).then(({action, activityType}) => {
            if (action === Share.sharedAction)
                console.log('Share was successful');
            else
                console.log('Share was dismissed');
        });
    }

    render() {
        let {user, token} = this.props.DataSplashSatiaScreen;
        let customer = customer && user.customer;
        let checkImageUser = customer && (customer.Image || customer.image);

        // let user = store.getState().reducerSplashGetAllData.resultsSaina.results.user.name;
        return (
            <KeyboardAvoidingView style={{flex: 1, backgroundColor: Colors.backgroundColor,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>
                {/*     <HMImageBackground

                />
*/}
                <View style={{flex: 1}}>
                    <HMActionBarSatia back menu props={this.props} statusBarTransparent
                                      text={i18n.t('constant.Information')} headerVisibility
                                      more_menu
                                      drawer
                                      onBackPress={() => this.props.navigation.pop()}/>
                    <ScrollView
                        style={{
                            //  backgroundColor: Colors.backgroundColor,
                        }}>

                        <View style={styles.container}>


                            <View style={{
                                // padding: moderateScale(6),
                                // width: '100%',

                                flex: 1,
                                backgroundColor: Colors.colorPrimary,
                                height: moderateScale(120),
                                flexDirection: 'row'
                            }}>
                                <Image
                                    source={PathFile.image.CityTransparent}
                                    //   source={require("../../assets/img/user.png")}
                                    resizeMode="stretch"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        alignSelf: 'center',
                                        width: '100%',
                                        height: moderateScale(120),
                                        //   backgroundColor: "#2d88ee",

                                        // tintColor: Colors.gray
                                    }}/>
                                <View style={{
                                    width: moderateScale(80),
                                    height: moderateScale(80),
                                    marginHorizontal: moderateScale(10),
                                    borderRadius: moderateScale(40),
                                    //    overflow:'hidden',
                                    alignSelf: 'center',
                                }}>
                                    <Image
                                        //  source={!this.state.pathImage && !user.Image ? require("../../assets/img/logo.png") : !this.state.pathImage ? {uri: user.Image} : {uri: this.state.pathImage}}
                                        //  source={{uri:"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Osteospermum_ecklonis1.JPG/500px-Osteospermum_ecklonis1.JPG"}}
                                        source={checkImageUser ? {uri: (customer.Image ? customer.Image : customer.image)} : PathFile.image.user}

                                        style={{

                                            width: moderateScale(80),
                                            height: moderateScale(80),
                                            borderRadius: moderateScale(40),

                                            // marginTop: moderateScale(10)
                                            // tintColor: Colors.gray
                                        }}/>

                                    <TouchableOpacity onPress={() => {
                                        this.setState({
                                            visibleModal: "selectImage"
                                        })
                                    }} style={{
                                        // height: moderateScale(40),
                                        borderRadius: moderateScale(15),
                                        width: moderateScale(30), height: moderateScale(30),
                                        backgroundColor: Colors.colorSecondPrimary,
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: 'absolute',
                                        bottom: moderateScale(0),
                                        left: moderateScale(0),
                                        zIndex: 3,

                                        //width: "80%"
                                    }}>
                                        <HMIcon style={{
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            fontSize: moderateScale(20),
                                            color: Colors.white,
                                            // backgroundColor:'#ee2a00',
                                            width: moderateScale(20),
                                            height: moderateScale(20),
                                        }} name={"ios-camera"} fontSize={10}/>
                                        {/*<HMTextView text={"انتخاب تصویر"}*/}
                                        {/*style={{color: "white", fontSize: moderateScale(14)}}/>*/}
                                    </TouchableOpacity>

                                </View>
                                <View style={{width: moderateScale(14)}}/>

                                <View style={{
                                    alignSelf: 'center',
                                    //  flexDirection: 'row',
                                    //marginTop: moderateScale(8)

                                }}>

                                    <View style={{flexDirection: 'row'}}>
                                        <HMTextView
                                            text={token && user ? user.customer.FName : ''}

                                            // text={token && user ? user.name : ''}
                                            // text={token && user ? user.name : ''}
                                            type={'bold'}
                                            style={{

                                                fontSize: moderateScale(15),
                                                color: Colors.white,
                                                //   textAlign: "right"
                                            }}/>
                                        <HMTextView text={token && user ? " " + user.customer.LName + " " : ''}
                                                    type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(15),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        // marginVertical: moderateScale(5)
                                                    }}/>
                                    </View>
                                    <View style={{width: moderateScale(6)}}/>

                                    <View style={{flexDirection: 'row'}}>
                                        <HMTextView text={token && user ? user.customer.Father : ''} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(12),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        marginVertical: moderateScale(1)
                                                    }}/>

                                    </View>
                                    <View style={{flexDirection: 'row', alignSelf: 'center',}}>
                                        <HMTextView text={token && user ? user.customer.AdslTel : ''} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(14),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        marginVertical: moderateScale(1)
                                                    }}/>
                                        <HMTextView text={'_'} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(14),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        marginVertical: moderateScale(1),
                                                        marginHorizontal: moderateScale(6)
                                                    }}/>
                                        <HMTextView text={token && user ? user.customer.Mobile : ''} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(14),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        marginVertical: moderateScale(1)
                                                    }}/>
                                    </View>
                                </View>


                            </View>
                            <HMListItem
                                title={"مشاهده اطلاعات"}
                                //   title={i18n.t('constant.Editing_information')}
                                //image={require("../../assets/img/editProfile.png")}
                                image={"md-create"}
                                onPress={() => {
                                    this.props.navigation.navigate("ChangeInformationSatiaScreen")
                                }}
                            />
                            {
                                1 !== 1 ?
                                    null
                                    :
                                    <HMListItem
                                        title={"وظایف"}
                                        //   title={i18n.t('constant.Editing_information')}
                                        //image={require("../../assets/img/editProfile.png")}
                                        image={"checklist"}
                                        typeIcon={"Octicons"}
                                        onPress={() => {
                                            this.props.navigation.navigate("TasksOperationSatiaScreen", {item: {title: "وظایف"}})
                                        }}
                                    />
                            }

                            <HMListItem
                                // title={"ویرایش اطلاعات"}
                                title={i18n.t('constant.UploadDocuments')}
                                //image={require("../../assets/img/editProfile.png")}
                                image={"ios-cloud-upload"}
                                onPress={() => {
                                    this.props.navigation.navigate("UploadDocumentSatiaScreen", {item: {title: i18n.t('constant.UploadDocuments')}})
                                }}
                            />
                            {/*   <HMListItem
                                title={"شارژ کیف پول"}
                                //  title2={"میزان اعتبار : " + this.props.wallet + " تومان )"}
                                title2={" ( میزان اعتبار : " + this.props.wallet + " تومان )"}
                                // image={require("../../assets/img/payment-method.png")}
                                image={"md-filing"}

                                onPress={() => {
                                    this.props.navigation.navigate("IncreaseCreditScreen")
                                }}
                            />*/}
                            {/*     <HMListItem
                                //title={"درخواست های من"}
                                title={i18n.t('constant.My_apply')}

                                //  image={require("../../assets/img/packing-list.png")}
                                image={"md-list"}
                                onPress={() => {
                                    this.props.navigation.navigate("ListMyApplyScreen")
                                }}
                            />*/}
                            <HMListItem
                                // title={"معرفی دوستان"}
                                title={i18n.t('constant.Introduce_friends')}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-share"}
                                NoShowIconOnpress
                                onPress={() => {
                                    onShare()
                                }}
                            />
                            {
                                1 === 1 ?
                                    null
                                    :
                                    <HMListItem
                                        // title={"تغییر رمز عبور"}
                                        title={i18n.t('constant.Change_Password')}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-lock"}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            this.props.navigation.navigate("ChangePassSatiaScreen", {forgot_my_password: false})
                                        }}
                                    />
                            }


                            {/*<HMListItem*/}
                            {/*title={"شرکت در مسابقه"}*/}
                            {/*//   image={require("../../assets/img/add-friend.png")}*/}
                            {/*image={"md-trophy"}*/}
                            {/*NoShowIconOnpress*/}
                            {/*onPress={() => {*/}
                            {/*this.setState({*/}
                            {/*showDialogCompetitions: true*/}
                            {/*})*/}
                            {/*}}*/}
                            {/*/>*/}
                            {/*<HMListItem*/}
                            {/*title={"طراحی و توسعه هونام مهارت"} image={require("../../assets/img/add-friend.png")}*/}
                            {/*onPress={() => {*/}
                            {/*Linking.openURL(UrlHoonam).catch(err => console.error('An error occurred', err))*/}
                            {/*}}*/}
                            {/*/>*/}

                            <HMListItem
                                //  title={"خروج از حساب کاربری"}
                                title={i18n.t('constant.Exit')}

                                NoShowIconOnpress
                                //image={require("../../assets/img/logout.png")}
                                image={"md-log-out"}

                                onPress={() => {
                                    exitApp()


                                }}
                            />


                        </View>

                    </ScrollView>
                    {/*{*/}
                    {/*this.state.showDialogCompetitions ?*/}

                    {/*<DialogCompetitions onPressCancel={() => {*/}
                    {/*this.setState({*/}
                    {/*showDialogCompetitions: false*/}
                    {/*})*/}
                    {/*}*/}
                    {/*}/>*/}
                    {/*:*/}
                    {/*null*/}
                    {/*}*/}
                    {/*{*/}
                    {/*this.ModalSelectImage()*/}
                    {/*}*/}
                </View>
            </KeyboardAvoidingView>

        );
    }

    ModalSelectImage() {
        return (
            <Modal
                style={{backgroundColor: Colors.transparent}}
                position={"center"}
                ref={"modal"}
                backdropPressToClose={true}
                coverScreen={true}
                swipeToClose={true}
                backButtonClose={true}
                isOpen={this.state.visibleModal}
                onClosed={() => this.setState({visibleModal: false})}
            >


                <View style={{
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>

                    <View style={{
                        width: '94%',
                        //  justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: Colors.white,
                        marginHorizontal: moderateScale(10),
                        // alignSelf: 'center',

                        // height:typeExport._WIDTH/2.7
                    }}>
                        <View style={{width: '100%'}}>
                            <TouchableOpacity
                                onPress={() => {
                                    ImagePicker.openCamera(typeExport.optional).then(image => {
                                        //   alert((image.size / 1048576).toFixed(2) + " mb")
                                        this.setState({
                                            pathImage: image.path,
                                            visibleModal: ''
                                        })
                                    });
                                }}
                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#eee',
                                    margin: moderateScale(5),
                                    padding: moderateScale(8),
                                    borderRadius: moderateScale(4),

                                }}>
                                <HMTextView
                                    text={"گرفتن عکس"}
                                    type={'bold'}
                                    style={{
                                        //   alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        textAlign: 'center',
                                        color: Colors.colorDarkText,
                                        fontSize: moderateScale(14),
                                    }}/>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={() => {
                                    ImagePicker.openPicker({
                                        width: 1000,
                                        height: 1000,
                                        cropping: true
                                    }).then(image => {
                                        this.setState({
                                            //ShowImage:true
                                            visibleModal: '',
                                            pathImage: image.path
                                        })
                                    });
                                }}
                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#eee',
                                    padding: moderateScale(8),
                                    margin: moderateScale(5),
                                    borderRadius: moderateScale(4)
                                }}>
                                <HMTextView
                                    text={"انتخاب عکس از گالری"}
                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        textAlign: 'center',
                                        color: Colors.colorDarkText,
                                        fontSize: moderateScale(14),
                                    }}/>
                            </TouchableOpacity>
                        </View>

                    </View>


                </View>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.reducerSplashSatiaScreen.user,
    wallet: state.reducerSplashSatiaScreen.wallet,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
});
export default connect(mapStateToProps, null)(ProfileSatiaScreen);

const styles = StyleSheet.create({
    container: {
        flex: 1,
        // backgroundColor: Colors.backgroundColor,
    },
    containerStyle: {
        alignSelf: 'center',
        width: window.width,
        overflow: 'hidden',
        height: window.width / 1.9
    },
    sliderContainerStyle: {
        borderRadius: window.width,
        width: window.width * 2,
        height: window.width * 2,
        marginLeft: -(window.width / 2),
        position: 'absolute',
        bottom: 0,
        overflow: 'hidden'
    },
    circle: {
        backgroundColor: Colors.light,
        width: moderateScale(80),
        height: moderateScale(80),
        alignItems: "center",
        justifyContent: "center",
        borderRadius: moderateScale(40),
        borderWidth: moderateScale(2),
        borderColor: Colors.colorPrimary
    }
});
